import PropTypes from 'prop-types';
import FreeBetsImpl from './free-bets-list.js';
import MojitoCore from 'mojito/core';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Free bets view displaying free bets list.
 *
 * @class FreeBetsList
 * @memberof Mojito.Modules.Betslip.BetslipView
 */

/**
 * Free bets list prop types.
 *
 * @property {Mojito.Services.Betslip.types.Betslip} betslip - Betslip object.
 * @property {Mojito.Services.Bonus.types.FreeBet[]} freeBets - Free bet object.
 * @property {Mojito.Services.Betslip.types.FreeBetConstraints} [freeBetConstraints] - Free bet constraints.
 *
 * @memberof Mojito.Modules.Betslip.BetslipView.FreeBetsList
 */
const propTypes = {
    betslip: PropTypes.object.isRequired,
    freeBets: PropTypes.array.isRequired,
    freeBetConstraints: PropTypes.object,
};

export default UIView('FreeBetsList', FreeBetsImpl, propTypes);
